export default "__VITE_ASSET__ThJ3aBmV__"